import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { configService, Configuration } from '@unpispas/upp-base';
import { UppGridConfiguration } from '@unpispas/upp-wdgt';

@Component({
    selector: 'demo-grid',
    templateUrl: './demo-grid.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoGridComponent {
    gridSize: 'SMALL' | 'LARGE' = 'SMALL';
    showItems = true;

    items = [
        { title: 'Product A', color: 'primary', icon: 'cube-outline' },
        { title: 'Product B', color: 'success', icon: 'leaf-outline' },
        { title: 'Product C', color: 'warning', icon: 'star-outline' },
        { title: 'Product D', color: 'danger', icon: 'flame-outline' },
        { title: 'Product E', color: 'tertiary', icon: 'diamond-outline' },
        { title: 'Product F', color: 'secondary', icon: 'rocket-outline' },
    ];

    private _config: Configuration | null = null;

    constructor(private config: configService, private change: ChangeDetectorRef) {
    }

    private get gridConfig(): Configuration {
        if (!this._config) {
            this._config = this.config.getConfiguration('DEMO_GRID');
        }
        return this._config;
    }

    get viewMode(): string {
        return String(this.gridConfig.get(UppGridConfiguration.viewmode) || 'GRID');
    }

    toggleViewMode() {
        const current = this.viewMode;
        this.gridConfig.set(UppGridConfiguration.viewmode, current === 'GRID' ? 'LIST' : 'GRID');
        this.gridConfig.commit();
        this.change.markForCheck();
    }

    toggleGridSize() {
        this.gridSize = this.gridSize === 'SMALL' ? 'LARGE' : 'SMALL';
    }

    toggleItems() {
        this.showItems = !this.showItems;
        this.change.markForCheck();
    }
}
